import type { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Paper(): Theme['components'] {
    return {
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },
    };
}
